import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {
  canAccessPaymentRoute,
  getPaymentAccessMode,
} from '../utils/payment-access.util';

@Injectable({ providedIn: 'root' })
export class PaymentGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    try {
      const groups = this.authService.currentUser()?.group;
      const targetUrl = state?.url ?? this.router.url ?? '';
      if (canAccessPaymentRoute(groups, targetUrl)) {
        return true;
      }
      if (getPaymentAccessMode(groups) === 'notice-only') {
        return this.router.createUrlTree(['/pages-dashboard']);
      }
      return this.router.createUrlTree(['/pages-dashboard']);
    } catch {
      return this.router.createUrlTree(['/pages-dashboard']);
    }
  }
}
